import { render } from "./ActiveSpeakingRooms.vue?vue&type=template&id=488ed19d&scoped=true&ts=true"
import script from "./ActiveSpeakingRooms.vue?vue&type=script&lang=ts"
export * from "./ActiveSpeakingRooms.vue?vue&type=script&lang=ts"

import "./ActiveSpeakingRooms.vue?vue&type=style&index=0&id=488ed19d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-488ed19d"]])

export default __exports__